import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  // Otimizado para usar Tailwind CSS para melhor estética e responsividade
  <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-800 p-4">
    <h1 className="text-6xl md:text-8xl font-extrabold text-red-600 mb-4 animate-bounce">
      404
    </h1>
    <p className="text-xl md:text-2xl font-semibold mb-2">
      Página Não Encontrada
    </p>
    <p className="text-md md:text-lg text-center mb-8 max-w-md">
      Ops! A rota que você tentou acessar não existe ou foi movida.
    </p>
    <Link
      to="/"
      className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition duration-300 ease-in-out transform hover:scale-105"
    >
      Voltar para a Página Inicial
    </Link>
  </div>
);

export default NotFoundPage;
